<!-- Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. -->
<dialog-titlebar [title]="strings.ORG_EDITOR_TITLE"></dialog-titlebar>

<mat-dialog-content>
	<div class="dialog-form">
		<div mat-dialog-content class="full-width item-list-container full-height">
			<mat-toolbar class="background-white mat-toolbar-dense">
				<mat-toolbar-row class="control-toolbar space-between">
					<button mat-button (click)="startAdd()" class="icon-button-with-text" automationId="addOrgBtn">
						<mat-icon>add_circle</mat-icon>
						<span class="spacing-side-sm">{{ strings.ORG_EDITOR_ADD_APPLICATION }}</span>
					</button>
				</mat-toolbar-row>
			</mat-toolbar>
			<!--  BEGIN PLACEHOLDER REPLACE AS PART OF TP-3580 (set proper itemSize)-->
			<cdk-virtual-scroll-viewport itemSize="73" class="item-list-scroll-pane">
				<!--  END PLACEHOLDER REPLACE AS PART OF TP-3580 -->

				<mat-divider></mat-divider>

				<div
					*ngIf="(applications$ | async)?.length === 0 && (organizationService.isEditing$ | async)"
					class="empty-item-list-container"
				>
					<mat-icon class="empty-item-list-logo">code</mat-icon>
					<p class="empty-item-list-title" automationId="noOrgApplications">
						{{ strings.ORG_EDITOR_NO_APPLICATIONS }}
					</p>
					<p>{{ strings.ORG_EDITOR_NO_APPLICATIONS_DESC }}</p>
				</div>

				<div *ngIf="(applications$ | async)?.length > 0" automationId="orgAppsList">
					<ng-container *cdkVirtualFor="let item of applications$ | async">
						<div
							[ngClass]="{
								'edit-item-panel':
									(organizationService.isEditing$ | async) &&
									item.$id === (organizationService.application$ | async)?.$id
							}"
						>
							<div class="two-column">
								<mat-card class="left-side-card clickable highlightable" (click)="startEdit(item)">
									<mat-card-title class="h3-heading-regular">
										{{ item?.view.name || strings.ORG_EDITOR_NAME_NOT_SET }}
									</mat-card-title>
									<mat-card-subtitle>
										{{ item?.view.description || '&nbsp;' }}
									</mat-card-subtitle>
								</mat-card>
							</div>
							<mat-divider></mat-divider>
						</div>
					</ng-container>
				</div>
			</cdk-virtual-scroll-viewport>
		</div>
		<add-edit-organization-app *ngIf="showEdit$ | async"> </add-edit-organization-app>
	</div>
	<!-- Loading state -->
	<div *ngIf="requestState$ | async as state" class="loading-background">
		<mat-status-indicator
			class="loading-indicator"
			[state]="state"
			[spinnerMode]="'indeterminate'"
			[scalePercent]="50"
		>
		</mat-status-indicator>
	</div>
</mat-dialog-content>
